<template lang="pug">
.charts
  #stock-charts
  .top.light
    span 目标价：{{targetPrice.max || '--' }}
    span 当前价：{{targetPrice.now || '--' }}
  .top-tip
    .triangle
    span {{targetPrice.max || '--'}}
  .avg.light
    span 平均价：{{targetPrice.avg || '--' }}
  .bottom.light
    span 最低价：{{targetPrice.min || '--' }}
  .bottom-tip
    .triangle
    span {{targetPrice.min || '--' }}
</template>

<script>
import Highcharts from 'highcharts/highstock'
import { dateToDateStr } from '@utils/time_helper'
import { Loading } from 'vant'

export default {
  name: 'StockCharts',
  components: {
    VantLoading: Loading
  },
  props: {
    chartData: Object
  },
  data() {
    return {
      targetPrice: {}
    }
  },
  watch: {
    chartData(newVal) {
      if (newVal) {
        this.init(newVal)
      }
    }
  },
  methods: {
    init(chartData) {
      this.targetPrice = chartData.targetPrice
      Highcharts.stockChart('stock-charts', {
        chart: {
          spacing: [20, 0, 0, 0]
        },
        navigator: { enabled: false },
        exporting: { enabled: false },
        scrollbar: { enabled: false },
        credits: { enabled: false },
        rangeSelector: { enabled: false },
        xAxis: {
          lineWidth: 0,
          gridLineWidth: 0,
          tickWidth: 0,
          dateTimeLabelFormats: {
            millisecond: '%H:%M:%S.%L',
            second: '%H:%M:%S',
            minute: '%H:%M',
            hour: '%H:%M',
            day: '%m-%d',
            week: '%m-%d',
            month: '%y-%m',
            year: '%Y'
          },
          labels: {
            y: 40
          }
        },
        tooltip: {
          crosshairs: true,
          shadow: false,
          useHTML: true,
          backgroundColor: 'rgba(27, 27, 27, 0.8)',
          borderWidth: 0,
          borderRadius: 15,
          formatter: function() {
            const point = this.points[0].point
            const rows = [dateToDateStr(new Date(point.x)), `开: ${point.open}`, `高: ${point.high}`, `低: ${point.low}`, `收: ${point.close}`].map(i => `<span>${i}</span>`).join('<br>')
            return `<div style="color: white">${rows}</div>` // <div style="color: white">${chartData.name}</div>
          }
        },
        yAxis: {
          labels: {
            enabled: false
          },
          tickPositions: [chartData.minData, chartData.maxData],
          max: chartData.maxData,
          min: chartData.minData,
          lineWidth: 0,
          gridLineWidth: 0,
          plotLines: [
            {
              color: '#95989e',
              dashStyle: 'Dash',
              value: chartData.maxData,
              width: 1,
              zIndex: 9
            },
            {
              color: '#95989e',
              dashStyle: 'Dash',
              value: chartData.minData,
              width: 1,
              zIndex: 9
            }
          ]
        },
        series: [{
          type: 'candlestick',
          color: '#47b58a',
          lineColor: '#47b58a',
          upColor: '#df3031',
          upLineColor: '#df3031',
          data: chartData.data,
          dataGrouping: {
            enabled: false
          }
        }]
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.charts
  position relative
  #stock-charts
    height 14.29rem
    display flex
    justify-content center
    align-items center
  .light
    font-size .86rem
  .top
    width 100%
    position absolute
    top 0
    z-index 9
    display flex
    justify-content space-between
  .avg
    position absolute
    top 50%
    z-index 9
  .bottom
    position absolute
    bottom 1.43rem
    z-index 9
  .top-tip
    .triangle
      height 0
      width 0
      border-top 10px solid #fff
      border-right 10px solid #47b58a
      transform rotate(45deg)
      position absolute
      top 0
      left 7.5rem
      z-index 9
    >span
      width 3.21rem
      text-align center
      background-color #47b58a
      position absolute
      color #fff
      top 0
      left 8.57rem
      z-index 9

  .bottom-tip
    .triangle
      height 0
      width 0
      border-top 10px solid #fff
      border-right 10px solid #df3031
      transform rotate(-135deg)
      position absolute
      bottom 1.43rem
      right 9.29rem
      z-index 9
    >span
      width 3.21rem
      background-color #df3031
      text-align center
      position absolute
      color #fff
      bottom 1.43rem
      right 5.71rem
      z-index 9

</style>
